module.exports = __webpack_public_path__ + "img/logo.93891be1.png";